import tailwindLocalCss from '../assets/tailwind-local.css?raw';

const OVERRIDE_CSS =
  '<style>html,body{margin:0!important;padding:0!important;background:#ffffff!important;overflow:hidden!important}</style>';

interface Options {
  full?: boolean;
}

export function augmentPreviewHtml(html: string, options: Options = {}): string {
  const withTailwind = html.replace(
    /<link[^>]*href="[^"]*tailwind-local\.css[^"]*"[^>]*\/?>/gi,
    () => `<style>${tailwindLocalCss}</style>`,
  );
  if (options.full) return withTailwind;
  return withTailwind.replace('</head>', `${OVERRIDE_CSS}</head>`);
}